import React from 'react';
import { useToast } from '../context/ToastContext';
import Toast from './Toast';
import './Toast.css';

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast key={toast.id} message={toast} onClose={removeToast} />
      ))}
    </div>
  );
};

export default ToastContainer;
